export const getError = ({ app }: any) => app.error;

export const getLoading = ({ app }: any) => app.loading;

export const getABTesting = ({ app }: any) => app.abTesting;
